import styled from 'styled-components';

export const Content = styled.main`
  height: 100%;
  background-color: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};
  overflow-y: hidden;
`;

export const ProductContent = styled.div`
  background-color: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};
  overflow-x: hidden;
`;
